module.exports = __webpack_public_path__ + "img/benefit-creatives.8ba5111a.jpg";